import React, { forwardRef } from 'react'
import { GlobalStyles as GlobalStylesBase, styled } from '@mui/material'
import { Close as CloseBase } from '@mui/icons-material'

export const GlobalStyles = props => {
  return (
    <GlobalStylesBase
      styles={`
        html {
          overflow: ${props.show ? 'hidden' : 'inherit'};
        }
      `}
    />
  )
}

export const Root = styled(
  forwardRef(({ disableBackdropColor, show, verticalAlign, ...props }, ref) => <div {...props} ref={ref} />)
)`
  align-items: ${props => {
    if (props.verticalAlign === 'bottom') {
      return 'flex-end'
    }

    if (props.verticalAlign === 'top') {
      return 'flex-start'
    }

    return 'center'
  }};
  background-color: ${props => (props.disableBackdropColor ? 'transparent' : props.theme.palette.gray[50.5])};
  display: ${props => (props.show ? 'flex' : 'none')};
  height: 100vh;
  justify-content: center;
  overflow-y: auto;
  width: 100%;

  &:focus-visible {
    outline: 0;
  }
`

export const Content = styled(
  forwardRef(({ margin, maxWidth, padding, position, ...props }, ref) => <div {...props} ref={ref} />)
)`
  background-color: ${props => props.theme.palette.brand.white};
  border: 1px solid ${props => props.theme.palette.brand.dialogBorder};
  border-radius: 4px;
  box-shadow: 0 3px 6px ${props => props.theme.palette.gray[0.16]};
  font-family: ${props => props.theme.typography.fontFamily};
  inset-block-start: 0;
  margin: ${props => props.margin};
  max-width: ${props => props.maxWidth};
  padding: ${props => props.padding};
  position: ${props => props.position || 'relative'};
  width: 100%;
`

export const CloseButton = styled('button')`
  background-color: transparent;
  border: 0;
  height: 1px;
  inset-block-start: 12px;
  padding: 0;
  position: absolute;
  right: 13px;
  z-index: 1000;

  &:focus {
    outline: none;
  }

  &:focus .MuiSvgIcon-root {
    background-color: ${props => props.theme.palette.gray[95]};
    border-radius: 50%;
    outline: none;
  }
`

export const CloseIcon = styled(CloseBase)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.gray[50]};
    cursor: pointer;
    font-size: 1.5rem;
  }
`
